import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const { t } = useTranslation();
  
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image - Flipped */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/e2dy74jj_Slide_Marimurtra_1200x700-11.jpg)',
          transform: 'scaleX(-1)'
        }}
      >
      </div>
      
      {/* Gradient Overlay - Not flipped, stays on left */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#003366]/90 via-[#0052CC]/70 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl">
            {t('hero.description')}
          </p>
          <Button
            onClick={scrollToContact}
            size="lg"
            className="bg-[#FFC400] hover:bg-[#DAA520] text-[#003366] text-lg px-8 py-6 group transition-all duration-300"
          >
            {t('hero.ctaButton')}
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;